import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';
import DuplicateSentDataLG from './DuplicateSentDataLG';

export const duplicateSentDataPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.user,
    path: '/data/duplicated-data',
    element: <DuplicateSentDataLG />,
  },
];
